export default "__VITE_ASSET__B78P15PY__"